export function getFileType(type) {
  let fileType = type.split('/')[0]
  switch (type) {
    case 'text/html':
    case 'text/css':
    case 'text/javascript':
    case 'text/json':
      fileType = 'code'
      break
    case 'application/pdf':
      fileType = 'pdf'
      break
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
    case 'application/vnd.ms-word.document.macroEnabled.12':
    case 'application/vnd.ms-word.template.macroEnabled.12':
      fileType = 'document'
      break
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
    case 'application/vnd.ms-excel.sheet.macroEnabled.12':
    case 'application/vnd.ms-excel.template.macroEnabled.12':
    case 'application/vnd.ms-excel.addin.macroEnabled.12':
    case 'application/vnd.ms-excel.sheet.binary.macroEnabled.12':
    case 'text/csv':
      fileType = 'sheet'
      break
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/vnd.openxmlformats-officedocument.presentationml.template':
    case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
    case 'application/vnd.ms-powerpoint.addin.macroEnabled.12':
    case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
    case 'application/vnd.ms-powerpoint.template.macroEnabled.12':
    case 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12':
      fileType = 'presentation'
      break
    case 'application/x-font-ttf':
    case 'application/x-font-openfileType':
    case 'application/font-woff':
    case 'application/font-woff2':
    case 'application/vnd.ms-fontobject':
    case 'application/font-sfnt':
      fileType = 'font'
      break
    case 'application/x-rar-compressed, application/octet-stream':
    case 'application/zip, application/octet-stream':
      fileType = 'compressed'
      break
    case 'application/photoshop':
      fileType = 'photoshop'
      break
    case 'application/illustrator':
      fileType = 'illustrator'
      break
  }

  return fileType
}

const acceptedTypeMap = {
  image: 'image/*',
  video: 'video/*',
  pdf: 'application/pdf',
  document:
    'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.ms-word.document.macroEnabled.12, application/vnd.ms-word.template.macroEnabled.12',
}

export function getAcceptedType(types) {
  if (typeof types === 'string') types = [types]

  if (!Array.isArray(types)) return ''

  return types.map(t => acceptedTypeMap[t] || '').join(', ')
}

export function formatBytes(a, b = 2) {
  if (0 == a) return '0 B'

  let c = 1024,
    d = b,
    e = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    f = Math.floor(Math.log(a) / Math.log(c))

  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
}
